import Abstract from "../../abstract-view/abstract.js";

import {
  createElement
} from "../../render/render.js";

const createCitySelectModalItemTemplate = (locality) => {
  return (
    `<li class="city-select-modal__cities-item">
      <button class="city-select-modal__cities-button">
        <span class="city-select-modal__cities-text">${locality}</span>
      </button>
    </li>`
  );
};

export default class CitySelectModalItem extends Abstract {
  constructor(locality) {
    super();

    this._buttonElement = null;
    this._localityTextElement = null;

    this._locality = locality;

    this._buttonClickHandler = this._buttonClickHandler.bind(this);
    this._buttonFocusHandler = this._buttonFocusHandler.bind(this);
  }

  getElement() {
    if (!this._element) {
      this._element = createElement(this._getTemplate());
    }

    return this._element;
  }

  getButtonElement() {
    if (!this._buttonElement) {
      this._buttonElement = this._element.querySelector(`button`);
    }

    return this._buttonElement;
  }

  getLocalityTextElement() {
    if (!this._localityTextElement) {
      this._localityTextElement = this._element.querySelector(`span`);
    }

    return this._localityTextElement;
  }

  activate() {
    this.getElement().classList.add(`${this.getElement().classList[0]}_active`);
    this.getButtonElement().classList.add(`${this.getButtonElement().classList[0]}_active`);
    this.getLocalityTextElement().classList.add(`${this.getLocalityTextElement().classList[0]}_active`);
    this.getButtonElement().tabIndex = `-1`;
  }

  deactivate() {
    this.getElement().classList.remove(`${this.getElement().classList[0]}_active`);
    this.getButtonElement().classList.remove(`${this.getButtonElement().classList[0]}_active`);
    this.getLocalityTextElement().classList.remove(`${this.getLocalityTextElement().classList[0]}_active`);
    this.getButtonElement().tabIndex = null;
  }

  hide() {
    this._element.style.display = `none`;
  }

  getLocality() {
    return this._locality;
  }

  setButtonClickHandler(callback) {
    this._callback.buttonClick = callback;
    this.getButtonElement().addEventListener(`click`, this._buttonClickHandler);
  }

  setButtonFocusHandler(callback) {
    this._callback.buttonFocus = callback;
    this.getButtonElement().addEventListener(`focus`, this._buttonFocusHandler);
  }

  _getTemplate() {
    return createCitySelectModalItemTemplate(this._locality);
  }

  _buttonClickHandler() {
    this._callback.buttonClick(this.getLocality());
  }

  _buttonFocusHandler() {
    this._callback.buttonFocus();
  }
}
